// Old slot ids and how to map them onto today's. Pure, with no Angular or database
// dependency, so the load-time repairs and their unit tests can use it without pulling
// in the exercise database service (which re-exports both functions for older callers).

const obsoleteSlotsRemappingTable: { [key: string]: string } = {
  "$biceps_5": "$biceps",
  "$bp2": "$bp",
  "$calves5": "$calves",
  "$chest2": "$chest",
  "$chest_3": "$chest",
  "$hams_3": "$hams",
  "$lats_4": "$lats",
  "$ohp7": "$ohp",
  "$rear_delt_3": "$rear_delt",
  "$squat_2": "$squat",
  "$triceps_3": "$triceps",
};

// in case the slot id is one of the old ones, remap it to the new one
// this accepts the slot id with or without the 'slot/' prefix and with or without the $ and number suffix
export function fixupSlotId(idSlot: string) {
  // pass through empty slots
  if (idSlot === undefined || idSlot === null || idSlot === '') {
    return idSlot;
  }
  if (idSlot === 'slot/$shoulders') {
    return 'slot/$ohp';// shoulders are obsolete, remap to OHP, at an unused offset
  }
  if (idSlot === '$shoulders$0') {
    return '$ohp$2';// shoulders are obsolete, remap to OHP, at an unused offset
  }

  // remove eventual prefix and suffix (it can be 'slot/' prefix and there can be additional $ and number suffix), but remember them so we can put them back
  let prefix: string = '';
  let suffix: string = '';
  let infixId: string = idSlot;
  let match = idSlot.match(/^(slot\/)?(.+?)(\$[0-9]+)?$/);
  if (match) {
    prefix = match[1] || '';
    infixId = match[2];
    suffix = match[3] || '';
  }
  let remappedId = obsoleteSlotsRemappingTable[infixId];

  // if nothing needs to be changed
  if (!remappedId) {
    // return the original id, so prevent eventual bugs in string manipulation 
    return idSlot;

    // if remapping is needed
  } else {
    // stitch the string back using the remapped id
    idSlot = prefix + remappedId + suffix;
    return idSlot;
  }
}

// check whether the slot id is one of the old ones
export function isObsoleteSlotId(idSlot: string) {
  return idSlot !== fixupSlotId(idSlot);
}
